// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"490":"7a178bcd","849":"c4cc51c1"}[chunkId] + ".chunk.js";
};